import React, { useState, useEffect, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Toggle } from "@ts-digital/vrc";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTasks, faTrashAlt, faRedo, faCog } from "@fortawesome/pro-regular-svg-icons";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "antd";
import Spinner from "../general/spinner";

import EmptyNotification from "./components/empty-notification";
import SingleNotification from "./components/single-notification";
import LoadingNotification from "./components/loading-notification";
import { getNotificationsList } from "../../store/actions/ncs/read";
import { updateNotifyPreferences } from "../../store/actions/ncs/preferences";
import { updateNotificationsList, deleteNotificationsList } from "../../store/actions/ncs/write";
import { Button } from "@ts-digital/vrc";
import "./style.css";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const NotificationDrawer = forwardRef( ({
  showNotificationList = false,
  setShowNotificationList,
  page,
  setPage
}, ref) => {

  const dispatchAction = useDispatch();
  const auth = useSelector(state => state.auth);
  const notificationsListStatus = useSelector(state => state.ncs.notifications.status);
  const notifications = useSelector(state => state.ncs.notifications.data);
  const user = useSelector(state => state.user);
  const myType = useSelector(state => state.main.myType);
  const isGettingPreferences = useSelector(state => state.ncs?.notifications?.isGettingPreferences);
  const notifyPreferences = useSelector(state => state.ncs?.notifications?.preferences);
  const result = Object.keys(notifyPreferences).map((key) => notifyPreferences[key]);

  const [docAppCheck, setDocAppCheck] = useState(true);
  const [docEmailCheck, setDocEmailCheck] = useState(true);
  const [noteEmailCheck, setNoteEmailCheck] = useState(true);
  const [noteAppCheck, setNoteAppCheck] = useState(true);
  const [askEmailCheck, setAskEmailCheck] = useState(true);
  const [askAppCheck, setAskAppCheck] = useState(true);
  const [deadlineEmailCheck, setDeadlineEmailCheck] = useState(true);
  const [deadlineAppCheck, setDeadlineAppCheck] = useState(true);
  const [flag, setFlag] = useState(false);

  const studioFind = GetSelectedCompanyStudio();
  
  useEffect(() => {
    if (isGettingPreferences === false && result) {
      if (result.length !== 0) {
        setDocAppCheck(result.find(n => n.templateType === "DBOX DOCUMENTS NEW FISCAL") && result.find(n => n.templateType === "DBOX DOCUMENTS NEW FISCAL")["channels"].includes("PUSH"));
        setDocEmailCheck(result.find(n => n.templateType === "DBOX DOCUMENTS NEW FISCAL") && result.find(n => n.templateType === "DBOX DOCUMENTS NEW FISCAL")["channels"].includes("EMAIL"));
        setNoteEmailCheck(result.find(n => n.templateType === "DBOX NUOVO COMMENTO") && result.find(n => n.templateType === "DBOX NUOVO COMMENTO")["channels"].includes("EMAIL"));
        setNoteAppCheck(result.find(n => n.templateType === "DBOX NUOVO COMMENTO") && result.find(n => n.templateType === "DBOX NUOVO COMMENTO")["channels"].includes("PUSH"));
        setAskEmailCheck(myType === "STUDIO" ? result.find(n => n.templateType === "DBOX RISPOSTA ASK") && result.find(n => n.templateType === "DBOX RISPOSTA ASK")["channels"].includes("EMAIL") : result.find(n => n.templateType === "DBOX NUOVO ASK") && result.find(n => n.templateType === "DBOX NUOVO ASK")["channels"].includes("EMAIL"));
        setAskAppCheck(myType === "STUDIO" ? result.find(n => n.templateType === "DBOX RISPOSTA ASK") && result.find(n => n.templateType === "DBOX RISPOSTA ASK")["channels"].includes("PUSH") : result.find(n => n.templateType === "DBOX NUOVO ASK") && result.find(n => n.templateType === "DBOX NUOVO ASK")["channels"].includes("PUSH"));
        setDeadlineEmailCheck(result.find(n => n.templateType === "DBOX NUOVE SCADENZE RICORRENTI") && result.find(n => n.templateType === "DBOX NUOVE SCADENZE RICORRENTI")["channels"].includes("EMAIL"));
        setDeadlineAppCheck(result.find(n => n.templateType === "DBOX NUOVE SCADENZE RICORRENTI") && result.find(n => n.templateType === "DBOX NUOVE SCADENZE RICORRENTI")["channels"].includes("PUSH"));
      } else {
        let templates = ["DBOX DOCUMENTS NEW COMPANY", "DBOX DOCUMENTS NEW FISCAL", "DBOX DOCUMENTS NEW HR", "DBOX DOCUMENTS NEW INBOX", "DBOX DOCUMENTS NEW INVOICE", "DBOX DOCUMENTS NEW OTHER", "DBOX NUOVO COMMENTO", "DBOX COMPENSA SCADENZE", "DBOX FRAZIONA SCADENZE", "DBOX NUOVA SCADENZA", "DBOX NUOVE SCADENZE RICORRENTI", "DBOX RAGGRUPPA SCADENZE", "DBOX SCADENZE IN SCADENZA"];
        if (myType === "STUDIO") {
          templates.push("DBOX RISPOSTA ASK");
        } else {
          templates.push("DBOX NUOVO ASK");
        }
        if (user.profile.ncsId)
          dispatchAction(updateNotifyPreferences(
            auth, user.profile.ncsId, ["WEB", "EMAIL", "PUSH"], templates
          ));
      }
    }

  }, [isGettingPreferences]);

  useEffect(() => {
    let channels = ["WEB"];
    if (flag) {
      if (docAppCheck) {
        channels.push("PUSH");
      }
      if (docEmailCheck) {
        channels.push("EMAIL");
      }
      if (user.profile.ncsId)
        dispatchAction(updateNotifyPreferences(
          auth, user.profile.ncsId, channels, ["DBOX DOCUMENTS NEW COMPANY", "DBOX DOCUMENTS NEW FISCAL", "DBOX DOCUMENTS NEW HR", "DBOX DOCUMENTS NEW INBOX", "DBOX DOCUMENTS NEW INVOICE", "DBOX DOCUMENTS NEW OTHER"]
        ));
    }
  }
  , [docAppCheck, docEmailCheck]);

  useEffect(() => {
    let channels = ["WEB"];
    if (flag) {
      if (noteAppCheck) {
        channels.push("PUSH");
      }
      if (noteEmailCheck) {
        channels.push("EMAIL");
      }
      if (user.profile.ncsId)
        dispatchAction(updateNotifyPreferences(
          auth, user.profile.ncsId, channels, ["DBOX NUOVO COMMENTO"]
        ));
    }
  }
  , [noteEmailCheck, noteAppCheck]);

  useEffect(() => {
    let channels = ["WEB"];
    let templates = [];
    if (flag) {
      if (myType === "STUDIO") {
        templates.push("DBOX RISPOSTA ASK");
      } else {
        templates.push("DBOX NUOVO ASK");
      }
      if (askAppCheck) {
        channels.push("PUSH");
      }
      if (askEmailCheck) {
        channels.push("EMAIL");
      }
      if (user.profile.ncsId)
        dispatchAction(updateNotifyPreferences(
          auth, user.profile.ncsId, channels, templates
        ));
    }
  }
  , [askEmailCheck, askAppCheck]);

  useEffect(() => {
    let channels = ["WEB"];
    if (flag) {
      if (deadlineAppCheck) {
        channels.push("PUSH");
      }
      if (deadlineEmailCheck) {
        channels.push("EMAIL");
      }
      if (user.profile.ncsId)
        dispatchAction(updateNotifyPreferences(
          auth, user.profile.ncsId, channels, ["DBOX COMPENSA SCADENZE", "DBOX FRAZIONA SCADENZE", "DBOX NUOVA SCADENZA", "DBOX NUOVE SCADENZE RICORRENTI", "DBOX RAGGRUPPA SCADENZE", "DBOX SCADENZE IN SCADENZA"]
        ));
    }
  }
  , [deadlineEmailCheck, deadlineAppCheck]);

  const getNcsNotificationsList = () => {
    if (user && user.profile.ncsId) {
      dispatchAction(getNotificationsList(auth.loginAuth, user.profile.ncsId));
    }
  };

  const updateNotificationsListRead = () => {
    if (user.profile.ncsId)
      dispatchAction(updateNotificationsList(
        auth.loginAuth, user.profile.ncsId, { read: true }
      ));
  };

  const deleteAllNotificaions = () => {
    if (user.profile.ncsId)
      dispatchAction(deleteNotificationsList(auth.loginAuth, user.profile.ncsId));
  };

  const renderNotificationSettings = () => {
    if (isGettingPreferences) return <Spinner size="large" />;
    return (
      <div >
        <div style={{
          width: "465px",
          color: "rgb(21, 41, 53)",
          fontSize: "16px",
          fontFamily: "Roboto",
          marginTop: "30px",
          marginBottom: "50px",
          marginLeft: "25px"
        }}><FormattedMessage id="notification.settingsDescription" /></div>
        {myType === "STUDIO" ?
          <div style={{ marginLeft: "25px", marginTop: "25px" }}>
            <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold" }}><FormattedMessage id="notification.newDocument" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setDocAppCheck(!docAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DOC-APP");
                  }
                }}
                checked={docAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setDocEmailCheck(!docEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DOC-EMAIL");
                  }
                }}
                checked={docEmailCheck} /></div>
              </div>
            </div>
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
            <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold" }}><FormattedMessage id="notification.newComment" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setNoteAppCheck(!noteAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-COMMENT-APP");
                  }
                }}
                checked={noteAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setNoteEmailCheck(!noteEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-COMMENT-EMAIL");
                  }
                }}
                checked={noteEmailCheck} /></div></div>
            </div>
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
            <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold" }}><FormattedMessage id="notification.askResponse" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setAskAppCheck(!askAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-ASK-APP");
                  }
                }}
                checked={askAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setAskEmailCheck(!askEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-ASK-EMAIL");
                  }
                }}
                checked={askEmailCheck} /></div></div>
            </div>
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
          </div>
          :
          <div style={{ marginLeft: "25px", marginTop: "25px", color: "rgb(21, 41, 53)" }}>
            {studioFind?.taxRegion !== "ES" && <><div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold" }}><FormattedMessage id="notification.deadlinesOperation" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setDeadlineAppCheck(!deadlineAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DEADLINE-APP");
                  }
                }}
                checked={deadlineAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setDeadlineEmailCheck(!deadlineEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DEADLINE-EMAIL");
                  }
                }}
                checked={deadlineEmailCheck} /></div></div>
            </div>
            {/* <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr> */}
            </>}
            {/* <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold" }}><FormattedMessage id="notification.newDocument" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setDocAppCheck(!docAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DOC-APP");
                  }
                }}
                checked={docAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setDocEmailCheck(!docEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-DOC-EMAIL");
                  }
                }}

                checked={docEmailCheck} /></div></div>
            </div> */}
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
            <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold", color: "rgb(21, 41, 53)" }}><FormattedMessage id="notification.newComment" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setNoteAppCheck(!noteAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-COMMENT-APP");
                  }
                }}
                checked={noteAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setNoteEmailCheck(!noteEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-COMMENT-EMAIL");
                  }
                }}
                checked={noteEmailCheck} /></div></div>
            </div>
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
            <div>
              <div style={{ marginTop: "30px", fontSize: "14px", fontWeight: "bold", color: "rgb(21, 41, 53)" }}><FormattedMessage id="notification.newAskReceived" /></div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "10px" }}>
                <div style={{ float: "right" }}><FormattedMessage id="notification.app" /></div>
                <div><FormattedMessage id="notification.email" /></div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly", marginLeft: "200px", marginBottom: "30px" }}>
                <div><Toggle onChange={e => {
                  setAskAppCheck(!askAppCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-ASK-APP");
                  }
                }}
                checked={askAppCheck} /></div>
                <div><Toggle onChange={e => {
                  setAskEmailCheck(!askEmailCheck);
                  setFlag(true);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-ASK-EMAIL");
                  }
                }}
                checked={askEmailCheck} /></div></div>
            </div>
            <hr style={{ background: "rgb(228, 234, 240)", borderRadius: "0px", height: "1px", width: "486px" }}></hr>
          </div>
        }
      </div>
    );
  };

  return (
    <div ref={ref} className={"notification-drawer" + (showNotificationList || page === 2 ? " show" : "")}>
      <div className="notification-drawer-header">
        {page === 1 ?
          <div>
            <FormattedMessage id="generic.notifications" /> ({notifications.length})
          </div> : <div><FormattedMessage id="generic.notificationsSettings" /></div>}
        {page === 1 ?
          <div>
            <Tooltip color={"rgb(0, 80, 117)"}
              placement="bottom" 
              title={<FormattedMessage id="notification.markAllAsRead" />}>
              <Button
                kind="tertiary"
                className="header-button"
                disabled={notifications.length > 0 && !notifications.find(n => n.read === false)}
                onClick={() => updateNotificationsListRead()}
              >
                <FontAwesomeIcon icon={faTasks} />
              </Button>
            </Tooltip>
            <Tooltip color={"rgb(0, 80, 117)"}
              placement="bottom" title={<FormattedMessage id="notification.removeAll" />}>
              <Button
                kind="tertiary"
                className="header-button"
                disabled={notifications.length === 0}
                onClick={() => deleteAllNotificaions()}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </Tooltip>
            <Tooltip 
              color={"rgb(0, 80, 117)"}
              placement="bottom" 
              title={<FormattedMessage id="generic.update" />}>
              <Button className="header-button"
                kind="tertiary"
                onClick={getNcsNotificationsList}>
                <FontAwesomeIcon icon={faRedo} />
              </Button>
            </Tooltip>
            <Tooltip
              color={"rgb(0, 80, 117)"}
              placement="bottomRight"
              arrowPointAtCenter={true}
              title={<FormattedMessage id="notification.settings" />}
            >
              <Button className="header-button"
                kind="tertiary"
                onClick={() => {
                  setPage(2);
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:NOTIFICATION-SETTINGS");
                  }
                }}>
                <FontAwesomeIcon icon={faCog} />
              </Button>
            </Tooltip>
          </div> : <div style={{ marginRight: "20px" }}>
            <Tooltip 
              color={"rgb(0, 80, 117)"}
              placement="bottom" 
              title={<FormattedMessage id="actions.close" />}>
              <FontAwesomeIcon style={{ color: "rgb(0, 144, 209) !important", cursor: "pointer" }} icon={["far", "times"]} onClick={() => { setShowNotificationList(true); setPage(1); }} />
            </Tooltip>
          </div>}

      </div>
      {page === 1 ?
        <div className="notification-drawer-content">
          {notifications.length ? (
            <div className="notification-drawer-container">
              {notifications.map(notification => (
                <SingleNotification
                  auth={auth}
                  key={notification.id}
                  title={notification.notification.title}
                  message={notification.notification.message}
                  date={notification.createdDate}
                  note={notification.note}
                  priority={notification.priority}
                  read={notification.read}
                  id={notification.id}
                  user={user}
                />
              ))}
            </div>
          ) : (
            <EmptyNotification />
          )}
          {notificationsListStatus.started && <LoadingNotification />}

        </div>
        : renderNotificationSettings()}

    </div>
  );
});

NotificationDrawer.defaultProps = {
  notificationsListStatus: { started: false }
};

NotificationDrawer.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    date: PropTypes.string,
    note: PropTypes.string,
    priority: PropTypes.oneOf(["LOW", "MEDIUM", "HIGH"]),
    read: PropTypes.bool,
    id: PropTypes.string
  })),
  getNotifications: PropTypes.func,
  deleteNotificationsList: PropTypes.func,
  deleteSingleNotification: PropTypes.func,
  updateSingleNotification: PropTypes.func,
  handleConfigureLinkClick: PropTypes.func,
  setNotificationsAsRead: PropTypes.func,
  show: PropTypes.bool
};

export default NotificationDrawer;
